var exports = {
  "b": "Scroller.module__scrollerWrap___T3NrdC",
  "XG": "Scroller.module__scroller___T3NrdC",
  "xM": "Scroller.module__horizontal___T3NrdC",
  "RN": "Scroller.module__scrollbarReserve___T3NrdC",
  "Uv": "Scroller.module__scrollerChildren___T3NrdC",
  "cB": "Scroller.module__dragging___T3NrdC",
  "Hg": "Scroller.module__regular___T3NrdC",
};

module.exports = exports;
